export default "__VITE_ASSET__Dz$0nUtt__"